import PropTypes from "prop-types"
import React, { useEffect } from "react"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//import actions
import { getDashboard } from "../../store/dashboard/actions"

const Dashboard = props => {
    //meta title
    document.title = "Content Management System (JVP)"

    const dispatch = useDispatch()
    const { dashboardData } = useSelector(state => state.dashboard)

    // Fetch dashboard data on component mount
    useEffect(() => {
        dispatch(getDashboard())
    }, [dispatch])

    // Statistics Cards Data - using API data or fallback to static
    const reports = dashboardData ? [
        {
            title: "Total Merchants",
            iconClass: "bx-store",
            description: dashboardData.totalMerchants || "0",
            color: "primary"
        },
        {
            title: "Live Merchants",
            iconClass: "bx-store-alt",
            description: dashboardData.liveMerchants || "0",
            color: "success"
        },
        {
            title: "Total Brands",
            iconClass: "bx-purchase-tag-alt",
            description: dashboardData.totalBrands || "0",
            color: "info"
        },
        {
            title: "Live Brands",
            iconClass: "bx-purchase-tag",
            description: dashboardData.liveBrands || "0",
            color: "success"
        },
        {
            title: "Total Initiated Offers",
            iconClass: "bx-receipt",
            description: dashboardData.totalInitiatedOffers || "0",
            color: "info"
        },
        {
            title: "Total Published Offers",
            iconClass: "bx-check-circle",
            description: dashboardData.totalPublishedOffers || "0",
            color: "success"
        },
        {
            title: "Total Live Offers",
            iconClass: "bx-broadcast",
            description: dashboardData.totalLiveOffers || "0",
            color: "warning"
        },
        {
            title: "Total Expired Offers",
            iconClass: "bx-time-five",
            description: dashboardData.totalExpiredOffers || "0",
            color: "secondary"
        },
        {
            title: "Total Upcoming Offers",
            iconClass: "bx-calendar-event",
            description: dashboardData.totalUpcomingOffers || "0",
            color: "info"
        },
        {
            title: "Total Posted Offers",
            iconClass: "bx-mail-send",
            description: dashboardData.totalPostedOffers || "0",
            color: "primary"
        },
        {
            title: "Total Rejected Offers",
            iconClass: "bx-x-circle",
            description: dashboardData.totalRejectedOffers || "0",
            color: "danger"
        },
        {
            title: "Total Processed Offers",
            iconClass: "bx-cog",
            description: dashboardData.totalProcessedOffers || "0",
            color: "info"
        },
        {
            title: "Total Denied Offers",
            iconClass: "bx-block",
            description: dashboardData.totalDeniedOffers || "0",
            color: "danger"
        },
    ] : []

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={"Dashboards"}
                        breadcrumbItem={"Dashboard"}
                    />

                    {/* Statistics Cards Row */}
                    <Row>
                        {reports.map((report, key) => (
                            <Col md="6" xl="4" key={"_col_" + key}>
                                <Card className="mini-stats-wid">
                                    <CardBody>
                                        <div className="d-flex">
                                            <div className="flex-grow-1">
                                                <p className="text-muted fw-medium">
                                                    {report.title}
                                                </p>
                                                <h4 className="mb-0">{report.description}</h4>
                                            </div>
                                            <div className={`avatar-sm rounded-circle bg-${report.color} align-self-center mini-stat-icon`}>
                                                <span className={`avatar-title rounded-circle bg-${report.color}`}>
                                                    <i
                                                        className={
                                                            "bx " + report.iconClass + " font-size-24"
                                                        }
                                                    ></i>
                                                </span>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

Dashboard.propTypes = {
    t: PropTypes.any,
}

export default Dashboard
